import styled from 'styled-components';
import MotifAccordionTrigger from '@ey/motif-react-wrapper/AccordionTrigger.js';

export default styled(MotifAccordionTrigger)`
	display: flex !important;
	/* padding: 0 0 0 var(--px-15) !important; */
	${(props) => (props.disabled ? 'pointer-events: none' : '')}
	.motif-accordion-icons {
		width: var(--px-20);
		height: var(--px-20);
		margin-top: var(--px-16);
		margin-right: 0;
		flex-shrink: unset;
	}
	.motif-accordion-title-content {
		width: calc(100% - var(--px-20));
	}
`;
